// Generated by purs version 0.13.8
"use strict";
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var DOM_HTML_Indexed_ButtonType = require("../DOM.HTML.Indexed.ButtonType/index.js");
var Data_DateTime = require("../Data.DateTime/index.js");
var Data_DateTime_Instant = require("../Data.DateTime.Instant/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Enum = require("../Data.Enum/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Time_Duration = require("../Data.Time.Duration/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Console = require("../Effect.Console/index.js");
var Effect_Now = require("../Effect.Now/index.js");
var Halogen_Aff_Util = require("../Halogen.Aff.Util/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Halogen_VDom_Driver = require("../Halogen.VDom.Driver/index.js");
var Sudoku_Generator = require("../Sudoku.Generator/index.js");
var Sudoku_Internal = require("../Sudoku.Internal/index.js");
var Sudoku_Internal_Generator = require("../Sudoku.Internal.Generator/index.js");
var Generate = (function () {
    function Generate() {

    };
    Generate.value = new Generate();
    return Generate;
})();
var NextGame = (function () {
    function NextGame(value0) {
        this.value0 = value0;
    };
    NextGame.create = function (value0) {
        return new NextGame(value0);
    };
    return NextGame;
})();
var NextDifficulty = (function () {
    function NextDifficulty(value0) {
        this.value0 = value0;
    };
    NextDifficulty.create = function (value0) {
        return new NextDifficulty(value0);
    };
    return NextDifficulty;
})();
var tableFrom = function (game) {
    return function (s) {
        var td$prime = Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("td") ]);
        var mkTable = (function () {
            var $45 = Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id_("table") ]);
            var $46 = Data_Functor.map(Data_Functor.functorArray)(Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("tr") ]));
            return function ($47) {
                return $45($46($47));
            };
        })();
        var displayChar = function (v) {
            if (v === ".") {
                return " ";
            };
            return Data_String_CodeUnits.singleton(v);
        };
        var rows = function (str) {
            return Sudoku_Internal.chunksOf(9)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
                return td$prime([ Halogen_HTML_Core.text(displayChar(v)) ]);
            })(Data_String_CodeUnits.toCharArray(str)));
        };
        var circle$prime = function (color) {
            return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("Circle"), Halogen_HTML_Properties.attr("Color")(color) ])([  ]);
        };
        var circle = function (v) {
            if (v === "R") {
                return circle$prime("Red");
            };
            if (v === "O") {
                return circle$prime("Orange");
            };
            if (v === "Y") {
                return circle$prime("Yellow");
            };
            if (v === "L") {
                return circle$prime("Lime");
            };
            if (v === "G") {
                return circle$prime("Green");
            };
            if (v === "B") {
                return circle$prime("Blue");
            };
            if (v === "I") {
                return circle$prime("Indigo");
            };
            if (v === "P") {
                return circle$prime("Purple");
            };
            if (v === "V") {
                return circle$prime("Violet");
            };
            return circle$prime("White");
        };
        var colorkuRows = function (str) {
            return Sudoku_Internal.chunksOf(9)(Data_Functor.map(Data_Functor.functorArray)(function (color) {
                return td$prime([ circle(color) ]);
            })(Data_String_CodeUnits.toCharArray(str)));
        };
        if (game instanceof Sudoku_Internal_Generator.Colorku) {
            return mkTable(colorkuRows(s));
        };
        if (game instanceof Sudoku_Internal_Generator.Wordoku) {
            return mkTable(rows(Data_String_Common.toUpper(s)));
        };
        if (game instanceof Sudoku_Internal_Generator.Sudoku) {
            return mkTable(rows(s));
        };
        throw new Error("Failed pattern match at Main (line 73, column 20 - line 76, column 36): " + [ game.constructor.name ]);
    };
};
var puzzleLabel = function (st) {
    var label = function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return " ";
        };
        if (v instanceof Data_Maybe.Just) {
            return Data_Show.show(Sudoku_Internal_Generator.showDifficulty)(v.value0.d) + (" " + Data_Show.show(Sudoku_Internal_Generator.showValues)(v.value0.g));
        };
        throw new Error("Failed pattern match at Main (line 111, column 5 - line 111, column 60): " + [ v.constructor.name ]);
    };
    return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.label([ Halogen_HTML_Properties.id_("label") ])([ Halogen_HTML_Core.text(label(st.displayed)) ]) ]);
};
var render = function (st) {
    return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("VContainer") ])([ Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("HContainer") ])([ Halogen_HTML_Elements.h1_([ Halogen_HTML_Core.text("Sudoku Generator") ]) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("HContainer") ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropButtonType)(DOM_HTML_Indexed_ButtonType.ButtonButton.value), Halogen_HTML_Properties.name(Data_Show.show(Sudoku_Internal_Generator.showDifficulty)(st.selected.d)), Halogen_HTML_Events.onClick(function (v) {
        return Data_Maybe.Just.create(new NextDifficulty(st.selected.d));
    }) ])([ Halogen_HTML_Core.text(Data_Show.show(Sudoku_Internal_Generator.showDifficulty)(st.selected.d)) ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropButtonType)(DOM_HTML_Indexed_ButtonType.ButtonButton.value), Halogen_HTML_Events.onClick(function (v) {
        return Data_Maybe.Just.create(new NextGame(st.selected.g));
    }) ])([ Halogen_HTML_Core.text(Data_Show.show(Sudoku_Internal_Generator.showValues)(st.selected.g)) ]) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("VContainer") ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.disabled(st.loading), Halogen_HTML_Properties.id_("Generate"), Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropButtonType)(DOM_HTML_Indexed_ButtonType.ButtonButton.value), Halogen_HTML_Events.onClick(function (v) {
        return new Data_Maybe.Just(Generate.value);
    }) ])([ Halogen_HTML_Core.text((function () {
        if (st.loading) {
            return "Working...";
        };
        return "Generate";
    })()) ]) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("label") ])([ tableFrom(Data_Maybe.maybe(Sudoku_Internal_Generator.Sudoku.value)(function (v) {
        return v.g;
    })(st.displayed))(st.puzzle), puzzleLabel(st) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("VContainer") ])([ Halogen_HTML_Elements.footer_([ Halogen_HTML_Core.text("PureScript + Netlify | Source on "), Halogen_HTML_Elements.a([ Halogen_HTML_Properties.href("https://github.com/nathaniel-may/purescript-wordoku") ])([ Halogen_HTML_Core.text("GitHub") ]) ]) ]) ]) ]);
};
var initialState = function (v) {
    return {
        selected: {
            d: Sudoku_Internal_Generator.Tricky.value,
            g: Sudoku_Internal_Generator.Wordoku.value
        },
        displayed: Data_Maybe.Nothing.value,
        loading: false,
        puzzle: Sudoku_Internal.emptySudoku
    };
};
var fromState = function (st) {
    return {
        variant: (function () {
            var $23 = Data_Eq.eq(Sudoku_Internal_Generator.valuesEq)(st.selected.g)(Sudoku_Internal_Generator.Wordoku.value);
            if ($23) {
                return Sudoku_Internal.UniqueDiagonal.value;
            };
            return Sudoku_Internal.Standard.value;
        })(),
        values: st.selected.g,
        difficulty: st.selected.d
    };
};
var cycle = function (dictEnum) {
    return function ($$default) {
        var $48 = Data_Maybe.fromMaybe($$default);
        var $49 = Data_Enum.succ(dictEnum);
        return function ($50) {
            return $48($49($50));
        };
    };
};
var handleAction = function (dictMonadAff) {
    return function (v) {
        if (v instanceof NextGame) {
            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                var $28 = {};
                for (var $29 in v1) {
                    if ({}.hasOwnProperty.call(v1, $29)) {
                        $28[$29] = v1[$29];
                    };
                };
                $28.selected = (function () {
                    var $25 = {};
                    for (var $26 in v1.selected) {
                        if ({}.hasOwnProperty.call(v1.selected, $26)) {
                            $25[$26] = v1["selected"][$26];
                        };
                    };
                    $25.g = cycle(Sudoku_Internal_Generator.valuesEnum)(Sudoku_Internal_Generator.Sudoku.value)(v.value0);
                    return $25;
                })();
                return $28;
            });
        };
        if (v instanceof NextDifficulty) {
            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                var $35 = {};
                for (var $36 in v1) {
                    if ({}.hasOwnProperty.call(v1, $36)) {
                        $35[$36] = v1[$36];
                    };
                };
                $35.selected = (function () {
                    var $32 = {};
                    for (var $33 in v1.selected) {
                        if ({}.hasOwnProperty.call(v1.selected, $33)) {
                            $32[$33] = v1["selected"][$33];
                        };
                    };
                    $32.d = cycle(Sudoku_Internal_Generator.difficultyEnum)(Sudoku_Internal_Generator.Beginner.value)(v.value0);
                    return $32;
                })();
                return $35;
            });
        };
        if (v instanceof Generate) {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Effect_Console.log("generating a " + (Data_Show.show(Sudoku_Internal_Generator.showDifficulty)(st.selected.d) + (" " + (Data_Show.show(Sudoku_Internal_Generator.showValues)(st.selected.g) + "..."))))))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                        var $39 = {};
                        for (var $40 in v1) {
                            if ({}.hasOwnProperty.call(v1, $40)) {
                                $39[$40] = v1[$40];
                            };
                        };
                        $39.loading = true;
                        return $39;
                    }))(function () {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Data_Functor.map(Effect.functorEffect)(Data_DateTime_Instant.toDateTime)(Effect_Now.now)))(function (start) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Control_Apply.applySecond(Effect_Aff.applyAff)(Effect_Aff.delay(4.0))(Effect_Aff.makeAff(function (cb) {
                                return function __do() {
                                    var val = Sudoku_Generator.generate(fromState(st))();
                                    cb(new Data_Either.Right(val))();
                                    return Effect_Aff.effectCanceler(Effect_Console.log("generation canceled"));
                                };
                            }))))(function (sudoku) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Data_Functor.map(Effect.functorEffect)(Data_DateTime_Instant.toDateTime)(Effect_Now.now)))(function (end) {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                        var $42 = {};
                                        for (var $43 in v1) {
                                            if ({}.hasOwnProperty.call(v1, $43)) {
                                                $42[$43] = v1[$43];
                                            };
                                        };
                                        $42.displayed = new Data_Maybe.Just(st.selected);
                                        $42.loading = false;
                                        $42.puzzle = sudoku;
                                        return $42;
                                    }))(function () {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Effect_Console.log("generated this game " + (Data_Show.show(Data_Time_Duration.showMilliseconds)(Data_DateTime.diff(Data_Time_Duration.durationMilliseconds)(end)(start)) + ":"))))(function () {
                                            return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Effect_Console.log(sudoku));
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        };
        throw new Error("Failed pattern match at Main (line 165, column 16 - line 180, column 34): " + [ v.constructor.name ]);
    };
};
var component = function (dictMonadAff) {
    return Halogen_Component.mkComponent({
        initialState: initialState,
        render: render,
        "eval": Halogen_Component.mkEval({
            handleAction: handleAction(dictMonadAff),
            handleQuery: Halogen_Component.defaultEval.handleQuery,
            receive: Halogen_Component.defaultEval.receive,
            initialize: Halogen_Component.defaultEval.initialize,
            finalize: Halogen_Component.defaultEval.finalize
        })
    });
};
var main = Halogen_Aff_Util.runHalogenAff(Control_Bind.bind(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitBody)(function (body) {
    return Halogen_VDom_Driver.runUI(component(Effect_Aff_Class.monadAffAff))(Data_Unit.unit)(body);
}));
module.exports = {
    main: main,
    Generate: Generate,
    NextGame: NextGame,
    NextDifficulty: NextDifficulty,
    component: component,
    initialState: initialState,
    fromState: fromState,
    cycle: cycle,
    tableFrom: tableFrom,
    puzzleLabel: puzzleLabel,
    render: render,
    handleAction: handleAction
};
